import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ErrorWrap } from "../../helpers/error";
import { FormField, Input } from "semantic-ui-react";
import React, { useState } from "react";
import {
  FormdataManager,
  getInitialState,
} from "../../components/common/formdata";
import type { FormProps } from "../../components/common/edit-entity";
import { EditEntity } from "../../components/common/edit-entity";
import { updateFileDir } from "../../redux/modules/file-dir";
import { t } from "../../constant/translations";

export const FolderEditFormComponent = (props: FormProps) => {
  const [state, setState] = useState({
    formData: null,
  });

  const { error } = props;
  const initialData = getInitialState(props.entity, props.initialData);
  const manager = new FormdataManager(
    state.formData || initialData,
    (formData) => setState({ formData }),
    initialData
  );
  return (
    <EditEntity
      manager={manager}
      header={t("file.change_directory")}
      useTextTrigger={true}
      {...props}
    >
      <FormField>
        <label>{t("labels.name")}</label>
        <Input
          placeholder={t("labels.name")}
          {...manager.getAttributes("name")}
        />
      </FormField>
    </EditEntity>
  );
};

function mapStateToProps(state) {
  return {
    error: ErrorWrap.fromError(state.fileDir.error),
    loading: state.fileDir.pending,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ update: updateFileDir }, dispatch);
}

export const FolderEditForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(FolderEditFormComponent);
